// project name
const PROJECT_NAME = 'bucha_'

// i18n
export const I18N_LANG = PROJECT_NAME + 'i18nextLng'

// auth
export const AUTH_TOKEN = 'buchaAuthToken'

export const CLIENT_CODE = PROJECT_NAME + 'client_code'
